"use client";

import { useEffect } from "react";
import useAuthStore from "../stores/useAuthStore";
import axiosInstance from "@/utils/axiosInstance";
import { useIpStore } from "@/stores/useIpStore";


export function AuthWrapper({ children }: { children: React.ReactNode }) {
  const fetchTokenAndUserData = useAuthStore(
    (state: any) => state.fetchTokenAndUserData
  );
  const setIpInfo = useIpStore((state: any) => state.setIpInfo);
  const { userData } = useAuthStore();

  useEffect(() => {
    fetchTokenAndUserData();
  }, [fetchTokenAndUserData]);

  useEffect(() => {
    if (userData?.id) {
      const fetchIpInfo = async () => {
        try {
          const ipInfo = await axiosInstance.post(
            `${process.env.NEXT_PUBLIC_API_URL_BASE}/users/insert-session/${userData?.id}`,
            {},
            { withCredentials: true }
          );

          //console.log(ipInfo);

          setIpInfo(ipInfo.data.userSesion);
        } catch (error) {
          //console.error("Error during logout:", error);
          throw new Error("Error during logout");
        }
      };

      fetchIpInfo();
    }
  }, [userData?.id]);

  return <>{children}</>;
}
